import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c56a09e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 -mt-8" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "overflow w-44" }
const _hoisted_4 = { class: "text-v_red w-24" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "text-v_red w-24" }
const _hoisted_7 = { class: "text-v_red w-24" }
const _hoisted_8 = { class: "text-v_red w-24" }
const _hoisted_9 = { class: "text-v_red w-24" }
const _hoisted_10 = { class: "text-v_red w-24" }

import { ModalContainer, ModalContentContainer, H1 } from "@/components/atoms"
import { VDataTableVirtual } from "vuetify/labs/VDataTable"
import { IItems } from "@/utils/interfaces"
import { PropType } from "vue"
import { hasPermission } from "@/utils/permissions"
import { Permission } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemsTable',
  props: {
	item: { type: Array as PropType<IItems[]>, required: true },
},
  setup(__props) {



const headers = [
	{ title: "Item", key: "item", sortable: false, tooltip: "Código do item" },
	{
		title: "Descrição",
		key: "description",
		sortable: false,
		tooltip: "Descrição do item",
	},
	{
		title: "Qtd",
		key: "amount",
		sortable: false,
		tooltip: "Quantidade do item",
	},
	{
		title: "R$ Rev",
		key: "rev",
		sortable: false,
		tooltip: "Preço que a revenda pagou",
	},
	{
		title: "R$ Final",
		key: "final",
		sortable: false,
		tooltip: "Preço que o cliente final pagou",
	},
	{
		title: "C. Bruta",
		key: "commission",
		sortable: false,
		tooltip: "Valor total de comissão",
	},
	{
		title: "ICMS",
		key: "icms",
		sortable: false,
		tooltip:
			"Imposto sobre Operações relativas à Circulação de Mercadorias e Prestação de Serviços de Transporte Interestadual e Intermunicipal e de Comunicação ",
	},
	{
		title: "IPI",
		key: "ipi",
		sortable: false,
		tooltip: "Imposto sobre Produtos Industrializados",
	},
	{
		title: "PIS",
		key: "pis",
		sortable: false,
		tooltip: "Programa de Integração Social",
	},
	{
		title: "Confins",
		key: "confins",
		sortable: false,
		tooltip:
			"Imposto de Contribuição para o Financiamento da Seguridade Social",
	},
	{
		title: "ISS/IR/CSLL",
		key: "issIrCsll",
		sortable: false,
		tooltip: "Imposto de Contribuição Social Sobre o Lucro Líquido",
	},
	{
		title: "Frete",
		key: "freight",
		sortable: false,
		tooltip: "Frete das mercadorias",
	},
	{
		title: "C. Líquida",
		key: "netCommission",
		sortable: false,
		tooltip: "Valor total de comissão com descontos",
	},
	{
		title: "Rebate",
		key: "rebate",
		sortable: false,
		tooltip: "Rebate",
	},
	{
		title: "Devolução",
		key: "devolution",
		sortable: false,
		tooltip: "Indicador se houve devolução ou não",
	},
]

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        w: "80%",
        h: "80%",
        class: "px-10"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 float-right w-8 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createVNode(_unref(H1), { class: "text-v_dark_blue -mt-8 mb-5" }, {
            default: _withCtx(() => [
              _createTextVNode("Itens")
            ]),
            _: 1
          }),
          _createVNode(_unref(VDataTableVirtual), {
            headers: headers,
            items: __props.item,
            class: "elevation-1",
            height: "600",
            "item-value": "name"
          }, _createSlots({
            item: _withCtx(({ item }) => [
              _createElementVNode("tr", _hoisted_2, [
                _createElementVNode("td", null, _toDisplayString(item.columns.item), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(item.columns.description), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(item.columns.amount), 1),
                _createElementVNode("td", null, _toDisplayString(item.columns.rev.toLocaleString("pt-BR", {
									style: "currency",
									currency: "BRL",
								})), 1),
                _createElementVNode("td", null, _toDisplayString(item.columns.final.toLocaleString("pt-BR", {
									style: "currency",
									currency: "BRL",
								})), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(
									item.columns.commission <= 0
										? 'text-v_red w-24'
										: 'text-v_green w-24'
								)
                  }, _toDisplayString(item.columns.commission.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_4, " -" + _toDisplayString(item.columns.icms.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, " -" + _toDisplayString(item.columns.ipi.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_7, " -" + _toDisplayString(item.columns.pis.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_8, " -" + _toDisplayString(item.columns.confins.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.columns.issIrCsll.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.columns.freight.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(
									item.columns.netCommission <= 0
										? 'text-v_red w-24'
										: 'text-v_green w-24'
								)
                  }, _toDisplayString(item.columns.netCommission.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(
									item.rebate == 0 ? 'text-v_green w-24' : 'text-v_black w-24'
								)
                  }, _toDisplayString(item.columns.rebate.toLocaleString("pt-BR", {
										style: "currency",
										currency: "BRL",
									})), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("p", {
                    class: _normalizeClass(item.devolution ? 'text-v_red w-32 block' : 'hidden')
                  }, " sim ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass(
									!item.devolution ? 'text-v_dark_blue w-32 block' : 'hidden'
								)
                  }, [
                    _createVNode(_component_v_icon, { icon: "mdi-dots-horizontal" })
                  ], 2)
                ])
              ])
            ]),
            _: 2
          }, [
            (_unref(hasPermission)([_unref(Permission).RESALE]))
              ? {
                  name: "headers",
                  fn: _withCtx(({ columns }) => [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: column.key,
                          class: "v-data-table__th"
                        }, [
                          _createElementVNode("h1", null, _toDisplayString(column.title), 1),
                          _createVNode(_component_v_tooltip, {
                            activator: "parent",
                            location: "top"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(column.tooltip), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})